import React from "react";
import { FormProvider } from "react-hook-form";
import { useNavigate, useParams } from "react-router";
import { toast } from "react-toastify";
import { FormatDateTime } from "../../../../../../utils/functions/ResourceFunctions";
import {
  useApproveDeclineAppraisalPeriodMutation,
  useGetSingleAppraisalQuery,
} from "../../../../../api/hrApi";
import DashboardStyle from "../../../../../dashboard/Styles/Dashboard.module.css";
import { ActionButtons } from "../../../../../global/components/Buttons/buttons";
import { FormTemplate } from "../../../../Components/Forms/InputTemplate";
import PageLayout from "../../../../Components/Layout/PageLayout";
import { getStatusText } from "../../../Finance/CostCenter/Class";
import ApproveModal from "../Modals/ApproveModal";
import { AppraisalDeclineModal } from "../Modals/DeclineModal";

export const ViewAppraisalPeriod = () => {
  const { id } = useParams();
  const { data } = useGetSingleAppraisalQuery(id);
  const navigation = useNavigate();
  const [approveDecline, { isLoading }] =
    useApproveDeclineAppraisalPeriodMutation();
  const [openApproveModal, setOpenApproveModal] = React.useState(false);
  const [openDeclineModal, setOpenDeclineModal] = React.useState(false);
  const [comment, setComment] = React.useState("");
    const declineVariable = 1;
  const approveVaiable = 0;
  const handleComment = (e) => {
    setComment(e.target.value);
  };
  const declineAction = async (type) => {
    if (!comment && type === 1) {
      toast.error("Please enter a comment");
      return;
    }
    try {
      const response = await approveDecline({
        id,
        comment,
        approvalType: type,
      }).unwrap();
      if (response?.successful) {
        setOpenDeclineModal(false);
        setOpenApproveModal(false);
        toast.success(response?.statusMessage);
        navigation("/dashboard/hr/HR-Appraisal-Setup/appraisal-period");
      }
    } catch (error) {
      toast.error(error?.data?.statusMessage ?? "Error approving Appraisal Period");
    }
  };

  const handleApproveModal = () => setOpenApproveModal(!openApproveModal);
  const handleDeclineModal = () => setOpenDeclineModal(!openDeclineModal);

  const getMonthName = (monthIndex) => {
    if (!monthIndex || typeof monthIndex !== "number") return "";
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    return months[monthIndex - 1] || "";
  };

  return (
    <PageLayout title={"Appraisal Period Details"} hasBack={true}>
      <FormProvider>
        <FormTemplate className={DashboardStyle.view_app_components}>
          <section
            style={{
              backgroundColor: "#F8FBF8",
              border: "1px solid #D9E9DA",
              borderRadius: "8px",
            }}
            className={DashboardStyle.form_section}
          >
            <h4 className={DashboardStyle.form_section_title}>
              Process <br /> Information
            </h4>
            <div className={DashboardStyle.labels_group}>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill, minmax(32.3%, 1fr))",
                  gap: "10px",
                }}
              >
                <div>
                  <p>Year:</p>
                  <h4>{data?.responseObject?.year}</h4>
                </div>
                <div>
                  <p>Start Month:</p>
                  <h4>{getMonthName(data?.responseObject?.startMonth)}</h4>
                </div>
                <div>
                  <p>End Month:</p>
                  <h4>{getMonthName(data?.responseObject?.endMonth)}</h4>
                </div>
                <div>
                  <p>Current Year:</p>
                  <h4>{data?.responseObject?.currentYear ? "Yes" : "No"}</h4>
                </div>
                <div>
                  <p>Approval Status:</p>
                  <h4>
                    {typeof data?.responseObject?.approvalStatus === "number"
                      ? getStatusText(data?.responseObject?.approvalStatus)
                      : data?.responseObject?.approvalStatus}
                  </h4>
                </div>
                <div>
                  <p>Created Date:</p>
                  <h4>
                    {FormatDateTime(
                      data?.responseObject?.createdDate,
                      "DD/MM/YYYY"
                    )}
                  </h4>
                </div>
              </div>
            </div>
          </section>
   
         {data?.responseObject?.approvalStatus !== 0 && <div className={DashboardStyle.button_cage}>
            <button
              width={"auto"}
              className={DashboardStyle?.button_cage_weight}
              onClick={handleApproveModal}
              type="button"
            >
              Approve
            </button>
            <ActionButtons
              width={"auto"}
              className={DashboardStyle?.button_cage_weight}
              style={{ backgroundColor: "red" }}
              onClick={handleDeclineModal}
              type="button"
            >
              Decline
            </ActionButtons>
          </div>}
        </FormTemplate>
      </FormProvider>
      {openDeclineModal && (
        <AppraisalDeclineModal
          openModal={openDeclineModal}
          closeModal={handleDeclineModal}
          handleComment={handleComment}
          handleDelete={() => declineAction(declineVariable)}
          isLoading={isLoading}
        />
      )}
      <ApproveModal
        isOpen={openApproveModal}
        handleClose={handleApproveModal}
        handleDelete={() => declineAction(approveVaiable)}
        handleComment={handleComment}
        isLoading={isLoading}
        headText={"Approve Appraisal Period"}
      />
    </PageLayout>
  );
};
